import * as Sentry from '@sentry/vue'
import { createPinia } from 'pinia'
import piniaPersist from 'pinia-plugin-persistedstate'
import PrimeVue from 'primevue/config'
import { createApp } from 'vue'
import App from './App.vue'
import { i18n } from './i18n'
import { router } from './router'
import { RozaPreset } from './theme'
import '@roza/shared/tokens.css'
import './styles/main.css'

const pinia = createPinia()
pinia.use(piniaPersist)

const app = createApp(App)

// Browser-side error reporting to self-hosted GlitchTip (12.7). The DSN host is allow-listed in
// the admin CSP connect-src (infra/nginx/snippets/admin-headers.conf).
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
  })
}

app
  .use(pinia)
  .use(router)
  .use(i18n)
  .use(PrimeVue, {
    theme: { preset: RozaPreset, options: { darkModeSelector: '.dark' } },
    locale: { firstDayOfWeek: 6 },
    ripple: false,
  })
  .mount('#app')

/*
 * The warehouse lane's service worker (G6.13).
 *
 * Registered only from inside `/m`, and scoped there: a worker installed at the root would sit in
 * front of every desktop screen in the panel for the sake of one lane, and would go on doing so
 * long after the tab that installed it was closed.
 *
 * Only in a real build. Under Vite's dev server the module graph is served unhashed and a worker
 * caching it hands you yesterday's component after every edit.
 *
 * A failure here is swallowed on purpose. The lane works without a worker — the offline tolerance
 * that matters is the transition queue, not stored assets — so a browser that refuses registration
 * (private mode, an insecure origin, a policy) should cost the operator nothing.
 */
if (import.meta.env.PROD && 'serviceWorker' in navigator && window.location.pathname.startsWith('/m')) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/m/sw.js', { scope: '/m/' }).catch(() => {
      // Deliberately silent; see above.
    })
  })
}
